import React from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'

function Contact() {
  const { locale, t } = useLocale()

  const getLocalizedPath = (page) => {
    return locale === 'fr' ? `/fr/${page}` : `/${page}`
  }

  return (
    <div className="container section">
      <h1>{t.contact.title}</h1>
      <p>
        {t.contact.description} <a style={{textDecoration: 'underline'}} href={`mailto:${t.contact.email}`}>{t.contact.email}</a>
      </p>

      <h2>{t.collectedData.title}</h2>
      <p>{t.collectedData.description}</p>

      <h2>{t.deleteAccount.title}</h2>
      <p>{t.deleteAccount.description}</p>
      <Link style={{textDecoration: 'underline'}} to={getLocalizedPath('account-deletion')}>{t.deleteAccount.link}</Link>
    </div>
  )
}

export default Contact
